import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./routes/home";
import Customizations from "./routes/customizations";
import Customization from "./routes/customization";
import RequestTrialForm from "./routes/request_trial_form";
import ContactForm from "./routes/contactForm";
import NotFound from "./routes/notfound";
import SingleCustomization from "./routes/singleCustomization";
import NavCustomization from "./components/NavCustomization";
import Contact from "./components/Contact";
import Resources from "./components/Resources";
import Layout from "./routes/layout";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoaded: false,
      items: [],
    };
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_URL)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
          });
        },
        // handle errors here
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  }

  render() {
    // eslint-disable-next-line
    const { error, isLoaded, items } = this.state;

    if (error) {
      return <div>Error: Something went wrong. </div>;
    } else if (!isLoaded) {
      return (
        <div
          style={{ textAlign: "center", paddingTop: "4em", fontSize: "1.5em" }}
        >
          Loading...
        </div>
      );
    } else {
      return (
        <div>
          <React.StrictMode>
            <div>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Layout items={this.state.items} />}>
                    <Route
                      path="/"
                      element={<Home items={this.state.items} />}
                    />
                    <Route
                      path="/customizations"
                      element={<Customizations items={this.state.items} />}
                    />
                    <Route
                      path="customization"
                      element={<Customization items={this.state.items} />}
                    >
                      <Route
                        path=":idx"
                        element={<NavCustomization items={this.state.items} />}
                      >
                        <Route
                          end
                          path=":custIdx"
                          element={<SingleCustomization />}
                        />
                        <Route path="*" element={<NotFound />} />
                      </Route>
                    </Route>
                    <Route
                      path="/request_trial_form"
                      element={
                        <RequestTrialForm
                          items={this.state.items}
                          isVerified={this.state.isVerified}
                        />
                      }
                    />
                    <Route
                      path="/contactForm"
                      element={<ContactForm items={this.state.items} />}
                    />
                    <Route path="contactus" element={<Contact />} />
                    <Route path="#" element={<Resources />} />
                    <Route path="*" element={<NotFound />} />
                  </Route>
                </Routes>
              </BrowserRouter>
            </div>
          </React.StrictMode>
        </div>
      );
    }
  } //end of render()
} //end of Data class
export default App;
